import { render, staticRenderFns } from "./LanguageInfo.vue?vue&type=template&id=4132a392"
import script from "./LanguageInfo.vue?vue&type=script&lang=ts"
export * from "./LanguageInfo.vue?vue&type=script&lang=ts"
import style0 from "./LanguageInfo.vue?vue&type=style&index=0&id=4132a392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports